// extracted by mini-css-extract-plugin
export default {"addressImageContainer":"Customized_addressImageContainer__mQVrW","addressImage":"Customized_addressImage__J3lP0"};